import React from 'react'

import { EDITOR_URL } from 'src/config'
import PageHeaderProduct from 'src/components/page-headers/PageHeaderProduct'

const WISTIA_STYLE_1: React.HTMLAttributes<HTMLDivElement>['style'] = {
  padding: '62.71% 0 0 0',
  position: 'relative',
}
const WISTIA_STYLE_2: React.HTMLAttributes<HTMLDivElement>['style'] = {
  height: '100%',
  left: 0,
  position: 'absolute',
  top: 0,
  width: '100%',
}

const Hero: React.FC<React.PropsWithChildren<unknown>> = () => (
  <PageHeaderProduct
    title="Create and customize from scratch"
    titleMaxWidth={8}
    subtitle="Introducing the SuperHi Editor&thinsp;&mdash;&thinsp;an intelligent code editor, made to make life a lot easier."
    buttonText="Use the Editor"
    buttonUrl={EDITOR_URL}
    buttonIsExternal
    backgroundColor="PALE_BLUE_40"
    version="2"
  >
    <div className="wistia_responsive_padding" style={WISTIA_STYLE_1}>
      <div className="wistia_responsive_wrapper" style={WISTIA_STYLE_2}>
        <iframe
          src="https://fast.wistia.net/embed/iframe/sfo3x2xrec?videoFoam=true"
          title="What is the SuperHi Editor? Video"
          allow="autoplay; fullscreen"
          frameBorder="0"
          scrolling="no"
          className="wistia_embed"
          name="wistia_embed"
          allowFullScreen
          // msAllowFullScreen
          width="100%"
          height="100%"
        ></iframe>
      </div>
    </div>
  </PageHeaderProduct>
)

export default Hero
